// Vuex module — Master Product (katalog SAP vs katalog POS).
//
// Halaman /offline-stores/master-product. Endpointnya di routes/routes/unionweb.php grup
// `/master-product`, dijaga auth:api + access (modul `masterproduct_*`). BACA SAJA: tidak
// ada aksi tulis sama sekali, dan itu disengaja — pos_products ditimpa sync per jam milik
// nfposbe, dan oitm read-only dari nfdashv2.
import $axios from "../../api";

const PREFIX = "unionweb/master-product";

const emptyPage = () => ({ rows: [], total: 0, page: 1, per_page: 25, last_page: 1, from: 0, to: 0 });
const emptySummary = () => ({ oitm_total: 0, pos_total: 0, orphan_total: 0, pos_last_changed: null, all_green: false, degraded: false });

const state = () => ({
  isLoading: false,
  list: emptyPage(),
  counts: null,
  summary: emptySummary(),
  verdictOptions: [],
  stockNote: "",
  page: 1,
});

const mutations = {
  SET_LOADING(s, v) {
    s.isLoading = v;
  },
  // Tahan payload undefined: jawaban 500 harus mengosongkan tabel, bukan melempar di mutasi.
  SET_LIST(s, v) {
    s.list = v ? { ...emptyPage(), ...v } : emptyPage();
    // `counts` sengaja boleh null — itu penanda mutu turun di atas FULL_SCAN_MAX, dan
    // layar menampilkannya sebagai "—", bukan 0 yang berbohong.
    s.counts = v?.counts ?? null;
    s.summary = v?.summary || emptySummary();
    s.verdictOptions = v?.verdict_options || [];
    s.stockNote = v?.stock_note || "";
  },
  SET_PAGE(s, v) {
    s.page = v;
  },
};

const fetchInto = async ({ commit, dispatch }, { path, params }) => {
  commit("SET_LOADING", true);
  try {
    const res = await $axios.get(`${PREFIX}/${path}`, { params });
    commit("SET_LIST", res.data?.data);

    return res.data;
  } catch (error) {
    commit("SET_LIST", null);
    dispatch("Main/globalSweetAlert", error.response || { message: "Unknown error" }, { root: true });
    throw error;
  } finally {
    commit("SET_LOADING", false);
  }
};

const actions = {
  getList(ctx, params = {}) {
    return fetchInto(ctx, { path: "list", params });
  },

  getOrphans(ctx, params = {}) {
    return fetchInto(ctx, { path: "orphans", params });
  },
};

export default { namespaced: true, state, mutations, actions };
